import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l('<path fill="#1EC160" d="M34.77 6.514A19.948 19.948 0 0 0 20 0C8.954 0 0 8.954 0 20c0 1.008.075 2 .219 2.967l34.55-16.453Z"></path><path fill="#DF2A40" d="M40 20c0 11.046-8.954 20-20 20a19.934 19.934 0 0 1-13.932-5.651l33.855-16.122c.05.584.077 1.176.077 1.773Z"></path><path fill="#FFD956" d="M.1 17.994c-.066.66-.1 1.33-.1 2.006 0 9.07 6.039 16.731 14.315 19.18L39.73 23.3c.178-1.073.271-2.176.271-3.3 0-8.611-5.442-15.951-13.074-18.768L.099 17.994Z"></path><path fill="#262626" d="M.493 24.431a20.014 20.014 0 0 0 7.833 11.81l31.39-19.614a19.985 19.985 0 0 0-7.185-12.215L.493 24.432Z"></path><path fill="#fff" fill-rule="evenodd" d="m33.158 16.07-2.009 3.181-1.304-3.53-3.646-.927 2.954-2.33-.245-3.756 3.13 2.09 3.495-1.393-1.02 3.622 2.405 2.894-3.76.149ZM10.49 29.811l-2.01 3.182-1.303-3.53-3.647-.927 2.955-2.33-.245-3.756 3.13 2.09 3.495-1.394-1.02 3.622 2.405 2.894-3.76.15Z" clip-rule="evenodd"></path>', 5), c = [
  o
];
function i(n, d) {
  return t(), e("svg", a, [...c]);
}
const p = { render: i };
export {
  p as default,
  i as render
};
